import { LOCATION_CHANGED } from '../ducks/routing.duck';
import { LOGIN_SUCCESS, SIGNUP_SUCCESS } from '../ducks/auth.duck';
import { CURRENT_USER_SHOW_SUCCESS } from '../ducks/user.duck';

// Reference to the dispatchAnalyticsEvent function provided by context
let dispatchAnalyticsEvent = null;

// Function to set the dispatch reference from the Analytics Context
export const setAnalyticsDispatch = (dispatch) => {
  dispatchAnalyticsEvent = dispatch;
};

// Redux middleware that sends analytics events to PostHog via the context
export const analyticsMiddleware = store => next => action => {
  // Let the action go through first
  const result = next(action);
  
  // If we have a connection to analytics context and it's a relevant action
  if (dispatchAnalyticsEvent) {
    const { type, payload } = action;
    
    // Track page views when location changes
    if (type === LOCATION_CHANGED) {
      const previousPath = store.getState()?.routing?.currentCanonicalPath;
      const { canonicalPath } = payload;
      
      dispatchAnalyticsEvent({
        type: 'track_page_view',
        payload: {
          canonicalPath,
          previousPath
        }
      });
    }
    
    // Track user after successful login or signup or when user data is fetched
    if (type === LOGIN_SUCCESS || type === SIGNUP_SUCCESS || type === CURRENT_USER_SHOW_SUCCESS) {
      const state = store.getState();
      const user = state.user.currentUser;
      
      if (user) {
        dispatchAnalyticsEvent({
          type: 'track_user',
          payload: {
            user
          }
        });
      }
    }
    
    // Add other analytics events as needed based on redux actions
  }
  
  return result;
}; 